/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Petr Mikušek <petr.mikusek@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

import ScheduleLayout from './schedule-layout';
import ScheduleRegion from './schedule-region';
import ScheduleContent, { ContentType } from './schedule-content';

// TODO #458 Schedule vrstvy nyní:
// 1. Vrstva úloh (ScheduleManager)
//   - Je třeba vybrat úlohu, která se má zobrazovat v nějakém okamžiku (teď).
//   - Nyní se vybere vždy jedna úloha. Následně bude propracováno při plánování dle kalendáře.
// 2. Vrstva slotů (ScheduleLayout)
//   - Rozdělení plochy na paralelní přehrávače médií.
//   - Dovolit zanořování, nebo řešit v ploché struktuře?
// 3. Vrstva strategií (ScheduleStrategy)
//   - Sériové přehrávání médií.
// TODO #458 Schedule vrstvy při zanoření šablony:
// - Nahoře zůstává vrstva úloh.
// - Vrstva strategií může obsahovat další vrstvu slotů.
// - Možná by bylo vhodné sloučit logiku pro rozvětvení obsahu:
//   ScheduleManager, ScheduleLayer, ScheduleTrack
//   ({layout, medium, playlist}) => ScheduleStrategy
// TODO #458 Přepracovat na ScheduleContentTask / ContentTaskScheduleStrategy / ContentTaskScheduler
// - Každopádně vracet jen jednu ScheduleStrategy.
/**
 * Správce plánování obsahu.
 * ![Diagram tříd](./core/schedule/schedule.doc.png)
 */
class ScheduleManager {
  /**
   * Vytvoří instanci.
   * @param {ViewerRegistry} viewerRegistry Registr informací o typech médií.
   */
  constructor(viewerRegistry) {
    this.viewerRegistry = viewerRegistry;
  }

  /**
   * Detekuje a vytvoří strategie pro plánování přehrávání obsahu.
   * @param {ContentTask|null} contentTask Obsahová úloha, pro kterou se mají strategie vytvořit.
   * @param {ContentInfo} contentInfo Informace o obsahu zařízení.
   * @returns {Array.<ScheduleStrategy>} Seznam detekovaných strategií.
   */
  createStrategies(contentTask, contentInfo) {
    if (isNil(contentTask)) {
      return [];
    }

    switch (ScheduleContent.type(contentTask)) {
      case ContentType.Layout:
        return (
          ScheduleLayout.createStrategies(
            contentInfo,
            contentTask.layout,
            this.viewerRegistry
          )
            // Každou scheduleStrategy (ScheduleLayer a případně ScheduleBackground)
            // zaobalíme top-level regionem s obsahem (nyní pouze top-level) šablony.
            .map(
              (scheduleStrategy) =>
                new ScheduleRegion(contentTask, scheduleStrategy)
            )
        );
      default:
        return [
          ScheduleRegion.fromContent(
            contentTask,
            contentInfo,
            this.viewerRegistry
          )
        ];
    }
  }
}

export default ScheduleManager;
